// extracted by mini-css-extract-plugin
export default {"words":"Words_words__x7jzc","h1":"Words_h1__vZDUR","ul":"Words_ul__HPYWY"};